
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"QUERY_AGES_DATA"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"districtdata"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"districts"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"Dornbirn","block":false},{"kind":"StringValue","value":"Feldkirch","block":false},{"kind":"StringValue","value":"Bregenz","block":false},{"kind":"StringValue","value":"Bludenz","block":false}]}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"data"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"district"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"newCases"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"activeCases"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"totalCases"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"incidence"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"deaths"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"totalDeaths"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"cured"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"totalCured"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"inhabitants"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"regiondata"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"data"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"region"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hospitalized"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hospitalFree"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"icu"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"icuFree"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tests"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"newCases"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"activeCases"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"totalCases"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"incidence"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"deaths"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"totalDeaths"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"cured"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"totalCured"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"countrydata"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"data"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"newCases"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"totalCases"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"deaths"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"totalDeaths"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"cured"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"totalCured"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastupdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"StringValue","value":"d.m.Y H:i:s","block":false}}],"directives":[]}]}}],"loc":{"start":0,"end":793}};
    doc.loc.source = {"body":"query QUERY_AGES_DATA($limit: Int) {\n  districtdata(\n    limit: $limit\n    districts: [\"Dornbirn\", \"Feldkirch\", \"Bregenz\", \"Bludenz\"]\n  ) {\n    date\n    data {\n      district\n      newCases\n      activeCases\n      totalCases\n      incidence\n      deaths\n      totalDeaths\n      cured\n      totalCured\n      inhabitants\n    }\n  }\n  regiondata(limit: $limit) {\n    date\n    data {\n      region\n      hospitalized\n      hospitalFree\n      icu\n      icuFree\n      tests\n      newCases\n      activeCases\n      totalCases\n      incidence\n      deaths\n      totalDeaths\n      cured\n      totalCured\n    }\n  }\n  countrydata(limit: $limit) {\n    date\n    data {\n      newCases\n      totalCases\n      deaths\n      totalDeaths\n      cured\n      totalCured\n    }\n  }\n  lastupdate(format: \"d.m.Y H:i:s\")\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["QUERY_AGES_DATA"] = oneQuery(doc, "QUERY_AGES_DATA");
        
